import { AfterViewInit, Directive, inject } from '@angular/core';
import { TrackerService } from '../services/tracker.service';
import { TRACKER_CONFIG, TRACKER_PARAMS } from '../tokens';


@Directive({
  selector: '[trackPageLifeCycle]',
  standalone: true
})
export class TrackPageLifeCycleDirective implements AfterViewInit {
  private _trackerService = inject(TrackerService);
  private _config = inject(TRACKER_CONFIG);
  private _params = inject(TRACKER_PARAMS);

  constructor() {}

  ngAfterViewInit(): void {
    if  (!this._config?.url) { 
      console.error('Tracker URL is not defined');
      return;
    }

    if  (!this._params) { 
      console.error('Tracker params are not defined');
      return;
    }

    this._trackerService.trackNavigation(this._config, this._params);
  }
}